























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class StoryPointsRow extends Vue {
  @Prop({ default: '' }) private storyPoints!: string;

  private currentValue: string = this.storyPoints;

  private resetValue() {
    this.currentValue = '';
    this.$emit('updateStoryPoints', this.currentValue);
  }
}
